import { Link  } from "react-router-dom"; 
import { FcSearch, FcCollect } from "react-icons/fc";
import ProfileDropdown from "./ProfileDropdown";
import MobileHamburger from "./MobileHamburger";

const Header = ()=>{
    return (
        <div className="container flex items-center justify-between h-full px-6 mx-auto text-purple-600 dark:text-purple-300">

{/* Mobile hamburger */}
<MobileHamburger/>

{/* end hamburger */}
            <div className="flex justify-center flex-1 lg:mr-32">
              <div
                className="relative w-full max-w-xl mr-6 focus-within:text-purple-500"
              >
                <div className="absolute inset-y-0 flex items-center pl-2">
                  <FcSearch />
                </div>
                <input  className="w-full pl-8 pr-2 text-sm text-gray-700 placeholder-gray-600 bg-gray-100 border-0 rounded-md h-8 form-input" type="text" placeholder="Search" aria-label="Search" />
              </div>
            </div>

            <ul className="flex items-center flex-shrink-0 space-x-6">
             
              {/* <!-- Notifications menu --> */}
              <li className="relative">
                <button className="relative align-middle rounded-md focus:outline-none focus:shadow-outline-purple"   aria-label="Notifications" aria-haspopup="true"
                >
                  <FcCollect/>
                  {/* <!-- Notification badge --> */}
                  <span  aria-hidden="true" className="absolute top-0 right-0 inline-block w-3 h-3 transform translate-x-1 -translate-y-1 bg-red-600 border-2 border-white rounded-full " ></span>
                </button>
                 
              </li>
              {/* <!-- Profile menu --> */}
              <li className="relative">
                
                <ProfileDropdown />
                
                  <ul  className="absolute right-0 w-56 p-2 mt-2 space-y-2 text-gray-600 bg-white border border-gray-100 rounded-md shadow-md hidden"  aria-label="submenu" >
                    <li className="flex">
                      <Link  className="inline-flex items-center w-full px-2 py-1 text-sm font-semibold transition-colors duration-150 rounded-md hover:bg-gray-100 hover:text-gray-800  " to={'#'}  >
                        <FcCollect/>
                        <span>Profile</span>
                      </Link>
                    </li>
                    <li className="flex">
                      <Link
                        className="inline-flex items-center w-full px-2 py-1 text-sm font-semibold transition-colors duration-150 rounded-md hover:bg-gray-100 hover:text-gray-800  "
                        to={'#'}
                      >
                        <FcCollect/>
                        <span>Settings</span>
                      </Link>
                    </li>
                    <li className="flex">
                      <Link
                        className="inline-flex items-center w-full px-2 py-1 text-sm font-semibold transition-colors duration-150 rounded-md hover:bg-gray-100 hover:text-gray-800  "
                        to={'#'}
                      >
                        <FcCollect/>
                        <span>Log out</span>
                      </Link>
                    </li>
                  </ul>
                 
              </li>
            </ul>

        </div>
    );

};

export default Header;